export const triggerCustomEvent = <T>(eventName: string, detail: T) => {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    detail
  });

  document.dispatchEvent(event);
};
